import service from '@/services/types/medioPago'

export const namespaced = true

export const state = () => ({
  list: []
})

export const mutations = {
  LIST: (state, objs) => (state.list = objs.filter(({ value }) => value !== '99'))
}

export const actions = {
  list: ({ commit, state }, value) => (state.list?.length ? state.list : service.list(value).then(result => commit('LIST', result) || result))
}

export const getters = {
  get: state => _id => state.list.find(({ id }) => id === _id),
  get_Id: state => value =>
    state.list.length !== 0
      ? state.list.find(item => {
          return item.value === value
        }).id
      : null
}
